import { useSetupSteps } from 'commons/useSetupSteps'
// import { useConfigAWS } from 'commons/useAWS';
import { useAppSettingsProvider } from 'commons/useAppSettings'
import { useMomentConfig } from './translations/useMomentConfis'
import { useUnleash } from 'commons/useUnleash'
import { useGoogleAnalytics } from 'libs/google-analytics'
import { useHotjar } from 'libs/hotjar'

const AppSetup = ({ children }) => {
  useSetupSteps()
  // useConfigAWS();
  useGoogleAnalytics()
  useHotjar()
  useAppSettingsProvider()
  useMomentConfig()
  useUnleash()
  return children
}

export default AppSetup
